import type { RootState } from '../store';

export const selectNotificationPreferences = (s: RootState) => s.notifications.preferences;
export const selectNotificationsStatus = (s: RootState) => s.notifications.status;
export const selectNotificationsPending = (s: RootState) => s.notifications.pending;
